import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <header className="header-container-v9">
        <div className="header-logo-v9" onClick={() => navigate('/')}>
          <h1>V9 <span>PrimeForce</span></h1>
        </div>

        <nav className="header-nav-v9 desktop-only">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/industries-served">Industries Served</Link>
          <Link to="/enquiry">Enquiry</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        {/* <div className="header-social-v9 desktop-only">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <i className="fab fa-x-twitter"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div> */}

        <div className="header-hamburger-v9" onClick={() => setIsOpen(true)}>
          <i className="fas fa-bars"></i>
        </div>
      </header>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="header-mobile-drawer-v9"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <div className="header-drawer-close-v9" onClick={() => setIsOpen(false)}>
              <i className="fas fa-xmark"></i>
            </div>

            <div className="header-drawer-links-v9">
              <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
              <Link to="/about" onClick={() => setIsOpen(false)}>About</Link>
              <Link to="/industries-served" onClick={() => setIsOpen(false)}>Industries Served</Link>
              <Link to="/enquiry" onClick={() => setIsOpen(false)}>Enquiry</Link>
              <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
            </div>

            <div className="header-drawer-social-v9">
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
